const value = {
    drag: 'Drag or ',
    chooseFile: 'choose file',
    uploadRules: '{{list}}, no more than {{maxSize}} MB',
    limitError: 'The file exceeds the allowed limit',
    extensionError: 'Invalid file format',
    fileInfo: '{{ext}}, size {{size}} MB',
  };

export default value;
